// extracted by mini-css-extract-plugin
export default {"GradientBG":"Home_GradientBG__IRCbM","BlackBG":"Home_BlackBG__9zXX9","fullBlackContainer":"Home_fullBlackContainer__Yt6u3"};